import * as Yup from 'yup'

export const schemaSupplierForecast = (t: (key: string) => string) => ({
  supplierProduct: Yup.object().shape({
    supplierUuid: Yup.string().required(t('requiredMessage')),
  }),
  quantity: Yup.number()
    .min(1, t('requiredMessage'))
    .required(t('requiredMessage')),
})
